import { useLayoutStore } from '@/store'
import { nextTick } from 'vue'

export function beforeEach(to, from) {
    var adminMain = document.querySelector('#adminui-main')
    if (!adminMain) { return false }
    const StoreLayout = useLayoutStore()
    StoreLayout.updateViewTags({
        fullPath: from.fullPath,
        scrollTop: adminMain.scrollTop
    })
}

export function afterEach(to) {
    var adminMain = document.querySelector('#adminui-main')
    if (!adminMain) { return false }
    nextTick(() => {
        const StoreLayout = useLayoutStore()
        var beforeRoute = StoreLayout.tagRouteList.filter(v => v.fullPath === to.fullPath)[0]
        if (beforeRoute) {
            adminMain.scrollTop = beforeRoute.scrollTop || 0
        }
    })
}
